// Annotated rather than re-exported straight from the .svg: `color` has to narrow to an accent
// role, which the ambient *.svg declaration cannot do per-folder. A plain annotation, not a cast —
// FC<SVGProps> is assignable to IconComponent because IconProps only narrows `color`.
import type {IconComponent} from "../iconProps";

import {ReactComponent as AI} from "./AI.svg";
import {ReactComponent as Add1} from "./Add1.svg";
import {ReactComponent as Add2} from "./Add2.svg";
import {ReactComponent as Back} from "./Back.svg";
import {ReactComponent as Close} from "./Close.svg";
import {ReactComponent as Cloud} from "./Cloud.svg";
import {ReactComponent as Copy} from "./Copy.svg";
import {ReactComponent as Delete} from "./Delete.svg";
import {ReactComponent as Edit} from "./Edit.svg";
import {ReactComponent as Education} from "./Education.svg";
import {ReactComponent as Export} from "./Export.svg";
import {ReactComponent as ExternalLink} from "./ExternalLink.svg";
import {ReactComponent as Eye} from "./Eye.svg";
import {ReactComponent as EyeOff} from "./EyeOff.svg";
import {ReactComponent as Fail} from "./Fail.svg";
import {ReactComponent as File} from "./File.svg";
import {ReactComponent as GetStarted} from "./GetStarted.svg";
import {ReactComponent as Import} from "./Import.svg";
import {ReactComponent as Remediate} from "./Remediate.svg";
import {ReactComponent as Restart} from "./Restart.svg";
import {ReactComponent as Spinner} from "./Spinner.svg";
import {ReactComponent as Star} from "./Star.svg";
import {ReactComponent as Status} from "./Status.svg";
import {ReactComponent as Success1} from "./Success1.svg";
import {ReactComponent as Success2} from "./Success2.svg";
import {ReactComponent as Time} from "./Time.svg";
import {ReactComponent as Warning} from "./Warning.svg";
import {ReactComponent as ChevronDown} from "./ChevronDown.svg";
import {ReactComponent as ChevronLeft} from "./ChevronLeft.svg";
import {ReactComponent as ChevronRight} from "./ChevronRight.svg";
import {ReactComponent as ChevronUp} from "./ChevronUp.svg";
import {ReactComponent as Error} from "./Error.svg";
import {ReactComponent as Help} from "./Help.svg";
import {ReactComponent as Info} from "./Info.svg";
import {ReactComponent as PushPin} from "./PushPin.svg";
import {ReactComponent as Revert} from "./Revert.svg";

export const AIIcon: IconComponent = AI;
export const Add1Icon: IconComponent = Add1;
export const Add2Icon: IconComponent = Add2;
export const BackIcon: IconComponent = Back;
export const CloseIcon: IconComponent = Close;
export const CloudIcon: IconComponent = Cloud;
export const CopyIcon: IconComponent = Copy;
export const DeleteIcon: IconComponent = Delete;
export const EditIcon: IconComponent = Edit;
export const EducationIcon: IconComponent = Education;
export const ExportIcon: IconComponent = Export;
export const ExternalLinkIcon: IconComponent = ExternalLink;
export const EyeIcon: IconComponent = Eye;
export const EyeOffIcon: IconComponent = EyeOff;
export const FailIcon: IconComponent = Fail;
export const FileIcon: IconComponent = File;
export const GetStartedIcon: IconComponent = GetStarted;
export const ImportIcon: IconComponent = Import;
export const RemediateIcon: IconComponent = Remediate;
export const RestartIcon: IconComponent = Restart;
export const SpinnerIcon: IconComponent = Spinner;
export const StarIcon: IconComponent = Star;
export const StatusIcon: IconComponent = Status;
export const Success1Icon: IconComponent = Success1;
export const Success2Icon: IconComponent = Success2;
export const TimeIcon: IconComponent = Time;
export const WarningIcon: IconComponent = Warning;
export const ChevronDownIcon: IconComponent = ChevronDown;
export const ChevronLeftIcon: IconComponent = ChevronLeft;
export const ChevronRightIcon: IconComponent = ChevronRight;
export const ChevronUpIcon: IconComponent = ChevronUp;
export const ErrorIcon: IconComponent = Error;
export const HelpIcon: IconComponent = Help;
export const InfoIcon: IconComponent = Info;
export const PushPinIcon: IconComponent = PushPin;
export const RevertIcon: IconComponent = Revert;
